<template>
    <div class="oneYuanGiftBag">
        <div class="top">
            <img src="http://wd-appdownload.oss-cn-beijing.aliyuncs.com/hrss-h5/gongxin/giftBagTop.jpg" alt="">
            <div class="time">
                活动有效期：<b>3</b>个月
            </div>
            <!-- <div class="time">仅剩<span>{{timeArr[0]}}</span>天<span>{{timeArr[1]}}</span>时<span>{{timeArr[2]}}</span>分</div> -->
            <div class="snapUp">
                <van-cell-group>
                    <van-field v-model="purchasePhone1" type="tel" label="" @click="phoneFocus('立即抢购')" placeholder="输入手机号码" />
                </van-cell-group>
                <div class="btn1" @click="purchase(1,'立即抢购','')">立即抢购</div>
            </div>
        </div>
        <div class="bottom">
            <img src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/hrss-h5/gongxin/bottom-three.png" alt="">
            <div class="student">
                <h3 class="title">最新领取学员</h3>
                <div class="list" id="box">
                    <ul id="ul1">
                        <li v-for="(item, index) in list" :key="index">
                            <!-- <span>用户名：</span> -->
                            <span>{{item.tel}}</span>
                        </li>
                    </ul>
                    <ul id="ul2"></ul>
                </div>
            </div>
            <div class="receive">
                <van-cell-group>
                    <van-field v-model="purchasePhone2" @click="phoneFocus('限时抢购')"  type="tel" label="" placeholder="输入手机号码" />
                </van-cell-group>
                <div class="btn2" @click="purchase(2,'限时抢购','')">限时抢购</div>
            </div>
            <!-- <div class="countDown">
                <div class="left"> -->
                    <!-- <h2>倒计时</h2> -->
                    <!-- <div>仅剩<span>{{timeArr[0]}}</span>天<span>{{timeArr[1]}}</span>时<span>{{timeArr[2]}}</span>分</div> -->
                    <!-- <span>活动有效期：<b>3</b>个月</span> -->
                <!-- </div>
                <div class="right" @click="apply"></div>
            </div> -->
        </div>
        <div class="buy">
           <img class="singleImg" src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/hrss-h5/gongxin/goBuy.png" />
           <div class="rightCircle"  @click="apply('活动有效期抢','')"></div>
        </div>
        <!-- <a href="tel:400-8555-686">报考咨询</a> -->
        <van-dialog
            class="receiveDialog"
            v-model="receiveDialogVisible"
            :showConfirmButton="false"
            :closeOnClickOverlay = "true"
            width="15.733rem"
        >
            <van-cell-group class="call" v-if="audition">
                <van-field v-model="tel" type="tel" @click="phoneFocus('活动有效期抢')" label="" placeholder="输入手机号码" />
            </van-cell-group>
            <div class="massage">
                <van-cell-group class="captcha">
                    <van-field v-model="captcha" @input="writeCode(buttonType==1?'立即抢购':buttonType==2?'限时抢购':'活动有效期抢')" type="number" label="" placeholder="输入验证码" />
                </van-cell-group>
                <div :class="['obtain', disabled ? 'disabled' : '']" @click="obtain">获取验证码{{submitText}}</div>
            </div>
            <div class="receive" @click="receive(captcha,buttonType==1?'立即抢购':buttonType==2?'限时抢购':'活动有效期抢')">立即领课</div>
        </van-dialog>
        <van-dialog
            class="cutScreenDialog"
            v-model="warningDialogVisible"
            :showConfirmButton="false"
            :closeOnClickOverlay = "true"
            width="13rem"
        >
            <div v-if="success">
                <img src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/hrss-h5/gongxin/right.png" alt="">
                <span>申请成功课程顾问与您联系</span>
            </div>
            <div v-else>
                <img src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/hrss-h5/gongxin/wrong.png" alt="">
                <span>您已申请成功 请勿重复提交</span>
            </div>
        </van-dialog>
    </div>
</template>

<script>
/*eslint-disable*/
export default {
    name: "oneYuanGiftBag",
    data() {
        return {
            receiveDialogVisible: false,
            warningDialogVisible: false,
            token: null,
            purchasePhone: null,
            purchasePhone1: null,
            purchasePhone2: null,
            tel: null,
            captcha: null,
            audition: true,
            success: false,
            goodsId: null,
            agentId: null,
            getWx: '',
            handelPaylist: '',
            goodsInfor: null,
            list: [
                {tel: '186****5424'},
                {tel: '137****2194'},
                {tel: '137****4580'},
                {tel: '183****6732'},
                {tel: '135****9724'},
                {tel: '185****8424'},
                {tel: '137****9986'},
                {tel: '189****5742'},
                {tel: '137****3412'},
                {tel: '135****8805'}
            ],
            ul1: null,
            ul2: null,
            box: null,
            stopDate: '2021/07/01 00:00:00',
            timeArr: [],
            disabled: true,
            frameTime: null,
            submitText: '',
            branchList: [],
            isOverdue: false, // 活动是否超过截止日期, a
            buttonType:null,
            consult:''
        };
    },
    watch: {},
    components: {},
    beforeDestroy() {
        clearInterval(this.timerId);
        clearInterval(this.knowTime);
    },
    destroyed() {},
    mounted() {
        this.token = localStorage.getItem("token")
            ? localStorage.getItem("token")
            : null;
        this.goodsId  = this.getQueryString('goodsId') || sessionStorage.getItem('goodsId');
        this.agentId =  this.getQueryString('distributionId') || sessionStorage.getItem('distributionId');
        sessionStorage.setItem('goodsId', this.goodsId);
        sessionStorage.setItem('distributionId', this.agentId);
        this.getWx = this.WeiXin(); // 判断是否微信 true
        window.onload = this.roll(50);
        // 倒计时临时被修改，时间 2021/05/24
        // 剩余时间
        // var nownow= new Date();
        //截止时间
        // var until= new Date(this.stopDate);
        // if (until > now) {
        //     this.timerId = setInterval(() => {
        //         if (until - now == 0) {
        //             clearInterval(this.timerId)
        //         } else {
        //             this.timeArr = this.calculateTime();
        //         }
        //     }, 1000);
        // } else {
        //     this.timeArr = this.calculateTime()
        // }
    },
    methods: {
        phoneFocus(scene){
            this.$sensors.track('click_phone_number_input',{
	              current_page: "一元课", 
	              current_scene: scene, 
            })
        },
        writeCode(scene){
           if(this.buttonType==1&&this.captcha.length==6 || this.buttonType==2&&this.captcha.length==6){
                this.$sensors.track('get_verification_code',{
	                current_page: "一元课", 
	                current_scene: scene, 
                    phone_number:this.purchasePhone,
                    is_succeed:1,
                    failed_reason:''
                })
            } 
            if(this.buttonType==3&&this.captcha.length==6){
                this.$sensors.track('get_verification_code',{
	                current_page: "一元课", 
	                current_scene: scene, 
                    phone_number:this.tel,
                    is_succeed:1,
                    failed_reason:''
                })
            }
        },
        // 剩余时间
        calculateTime() {
            // 剩余时间
            var now= new Date();
            //截止时间
            var until= new Date(this.stopDate);
            if (until > now) {
                var days = (until- now)/1000/3600/24; 
                // 下面都是简单的数学计算 
                var day = Math.floor(days);
                var hours = (days - day)*24;
                var hour = Math.floor(hours);
                var minutes = (hours - hour)*60;
                var minute = Math.floor(minutes);
                // var seconds = (minutes - minute)*60;
                // var second = Math.floor(seconds);
                return [day,hour,minute]
            } else {
                this.isOverdue = true
                clearInterval(this.timerId)
                return [0,0,0]
            }
        },
        roll(t) {
            this.ul1 = document.getElementById("ul1");
            this.ul2 = document.getElementById("ul2");
            this.box = document.getElementById("box");
            this.ul2.innerHTML = this.ul1.innerHTML;
            this.box.scrollTop = 0;
            setInterval(this.rollStart, t);
        },
        rollStart() {
            if (this.box.scrollTop >= this.ul1.scrollHeight) {
                this.box.scrollTop = 0;
            } else {
                this.box.scrollTop++;
            }
        },
        getQueryString(name) {
            var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
            var r = window.location.search.substr(1).match(reg);
            if (r != null) return unescape(r[2]);
            return null;
        },
        // 立即抢购
        purchase(type,button_name,consult) {
            if(this.isOverdue) {
                this.$toast({
                    message: "活动已过期",
                    position: 'top',
                })
                return 
            }
            this.$sensors.track('click_button',{
	                    current_page: "一元课", 
	                    button_name: button_name, 
                        consult:consult
            })
            // if (this.token) {
            //     // 发送请求判断是否已购买
            //     this.checkUserCanByGoods(this.goodsId)
            // } else {
                if (type == 1) {
                    this.buttonType=1
                    this.consult="立即抢购"
                    this.purchasePhone = this.purchasePhone1;
                } else if (type == 2) {
                    this.buttonType=2
                    this.consult="限时抢购"
                    this.purchasePhone = this.purchasePhone2;
                }
                if (!this.purchasePhone) {
                    this.$toast({
                        message: '请输入手机号',
                    });
                } else {
                    if (/^1(?:3[0-9]|4[5-9]|5[0-9]|6[12456]|7[0-8]|8[0-9]|9[0-9])[0-9]{8}$/.test(this.purchasePhone)) {
                        // 非试听
                        this.audition = false;
                        this.tel = null;
                        this.captcha = null;
                        this.receiveDialogVisible = true;
                        clearInterval(this.knowTime);
                        this.postAccountGetAuthCode();
                    } else {
                        this.$toast({
                            message: '手机号格式有误',
                        }); 
                    }  
                }
            // }
        },
        // 弹框三秒倒计时
        setFrameTime(num) {
            this.frameTime = num;
            this.knowTime = setInterval(() => {
                num -= 1;
                this.frameTime = num;
                if (this.frameTime < 0) {
                    clearInterval(this.knowTime);
                    this.submitText = '';
                    this.disabled = false;
                } else {
                    this.submitText = "(" + this.frameTime + ")";
                }
            }, 1000)
        },
        getApplyStaus(id) {         
            this.$api.initTrainingIdx.getApplyStatus(
                {
                    goodsId: id
                }
                ).then((res) => {
                if (res.data) { 
                    this.goodsInfor = res.data         
                }  else {
                    this.$toast({
                        message: res.message,
                        duration: 4000,
                        position: 'top',
                    }); 
                }
            })        
        },
        //查看商品是否购买；
        checkUserCanByGoods(id,scene) {
            let params = {
                goodsId: id
            };
            this.$api.home.checkUserCanByGoods({ params }).then(data => {
                this.isStudy = data.data;
                if (this.isStudy == true) {
                    // 未购买
                    if(this.buttonType==1 || this.buttonType==2){
                        this.$sensors.track('get_course',{
	                        current_page: "一元课", 
	                        current_scene: scene, 
                            phone_number:this.purchasePhone,
                            is_succeed:1,
                            failed_reason:""
                        })
                    }
                    if(this.buttonType==3){
                        this.$sensors.track('get_course',{
	                        current_page: "一元课", 
	                        current_scene: scene, 
                            phone_number:this.tel,
                            is_succeed:1,
                            failed_reason:""
                        })
                    }
                    this.payment(id).then(res => {
                        if (res.data) {
                            this.handelPaylist = res.data;
                            this.handelPay();                   
                        } else {
                            this.$toast({
                                message: res.message,
                                duration: 4000,
                            });                    
                        }
                    });
                    // this.$router.push({
                    //     path: "/gongxin_payment",
                    //     query: {
                    //         id: this.goodsId,
                    //         iswx: 0,
                    //         agentId: this.agentId + ''

                    //     }
                    // });
                } else if (this.isStudy == false) {
                    // 已购买
                    if(this.buttonType==1 || this.buttonType==2){
                        this.$sensors.track('get_course',{
	                        current_page: "一元课", 
	                        current_scene: scene, 
                            phone_number:this.purchasePhone,
                            is_succeed:0,
                            failed_reason:"您已申请成功，请勿重复提交"
                        })
                    }
                    if(this.buttonType==3){
                        this.$sensors.track('get_course',{
	                        current_page: "一元课", 
	                        current_scene: scene, 
                            phone_number:this.tel,
                            is_succeed:0,
                            failed_reason:"您已申请成功，请勿重复提交"
                        })
                    }
                    this.$toast({
                            message: "您已申请成功，请勿重复提交",
                        }
                    );
                }else{
                    if(this.buttonType==1 || this.buttonType==2){
                        this.$sensors.track('get_course',{
	                        current_page: "一元课", 
	                        current_scene: scene, 
                            phone_number:this.purchasePhone,
                            is_succeed:data.success?1:0,
                            failed_reason:data.message
                        })
                    }
                    if(this.buttonType==3){
                        this.$sensors.track('get_course',{
	                        current_page: "一元课", 
	                        current_scene: scene, 
                            phone_number:this.tel,
                            is_succeed:data.success?1:0,
                            failed_reason:data.message
                        })
                    }
                }
            });
        },
        payment(id) {
            return this.$api.initTrainingIdx
                .placeOrder({
                    // 调用订单号
                    data: {
                        goodsId: id,
                        orderSource: 2,
                        agentId: this.agentId + ''
                    }
                })
        },
        handelPay() {
            this.$api.home
                .prePayOrder({
                    // 调用订单号
                    data: {
                        orderId: this.handelPaylist.id,
                        orderNo: this.handelPaylist.orderNo,
                        totalMoney: this.goodsInfor.salePrice,
                        payInfoDesc: "",
                        scene: this.getWx ? 101 : 4
                    }
                })
                .then(res => {
                    if (res.message === "success") {
                        let hostname = window.location.hostname
                        let port = window.location.port;
                        let isIP=/^(\d+)\.(\d+)\.(\d+)\.(\d+)$/;
                        let arr =  hostname.split('.');
                        let isDTYProEnv = !hostname.split('.').splice(3).join('.'); //线上的定制化主题

                        let API = arr[0].includes('hrss') ?  `https://pay.${arr.splice(1).join('.')}` : `https://pay.${isDTYProEnv ? arr.splice(1).join('.') : arr.splice(2).join('.')}`
                        // let API = 'https://aic.saas-h5.fat.wdeduc.com';
                        if(isIP.test(hostname) || hostname.includes('dev') || !!port){
                            API = 'http://localhost:8080';
                        }    
                        const pathUrl = window.location.href.split('com')[1]
                        localStorage.setItem('showPageOfyuan', this.$route.query.pathUrl)
                        
                        // window.open(API  + "/cashier?orderNo=" + this.handelPaylist.orderNo + '&token=' + localStorage.getItem('token') + '&organ=' + localStorage.getItem('organ') + '&actor=' + localStorage.getItem('actor') + '&branch=' + localStorage.getItem('branch') + '&referId=' + this.handelPaylist.goodsList[0].referId + '&backUrl=' + window.location.origin +"&id=" + this.goodsId + "&referId=" + this.handelPaylist.goodsList[0].referId + '&theme=gongxin&type=pay&agentId=' + this.agentId, '_self');
                        window.open(API  + "/cashier?orderNo=" + this.handelPaylist.orderNo + '&token=' + localStorage.getItem('token') + '&organ=' + localStorage.getItem('organ') + '&actor=' + localStorage.getItem('actor') + '&branch=' + localStorage.getItem('branch') + '&referId=' + this.handelPaylist.goodsList[0].referId + '&backUrl=' + window.location.origin +"&id=" + this.goodsId + "&referId=" + this.handelPaylist.goodsList[0].referId + '&theme=gongxin&type=pay&agentId=' + this.agentId+`&consult=${this.consult}&isMaiDian=1&phone=${this.buttonType==3?this.tel:this.purchasePhone}`, '_self');
                        
                   }
                });

        },

        WeiXin() {
            // 判断是否是微信内置浏览器
            let isWeiXin = () => {
                return (
                    navigator.userAgent
                        .toLowerCase()
                        .indexOf("micromessenger") !== -1
                );
            };
            if (isWeiXin()) {
                return true;
            } else {
                return false;
            }
        },
        obtain() {
            if (this.audition) {
                if (this.tel) {
                    if (/^1(?:3[0-9]|4[5-9]|5[0-9]|6[12456]|7[0-8]|8[0-9]|9[0-9])[0-9]{8}$/.test(this.tel)) {
                        if (!this.disabled) {
                            this.purchasePhone = this.tel;
                            this.postAccountGetAuthCode()
                        }
                    } else {
                        this.$toast({
                            message: '手机号格式有误',
                            position: 'top',
                        }); 
                    }
                } else {
                    this.$toast({
                        message: '请输入手机号',
                        position: 'top',
                    });
                }
            } else {
                if (!this.disabled) {
                    this.postAccountGetAuthCode()
                }
            }
        },
        // 发送验证码
        postAccountGetAuthCode () {
            const data = { phone: this.purchasePhone, distributionId: this.agentId };
            this.$api.usercenter.postAccountGetAuthCode({ data }).then(res => {
                if (res.data) {
                    this.$toast(
                        {
                            message: '验证码已发送',
                            position: 'top',
                        });
                    this.disabled = true;
                    this.submitText = "(60)";
                    this.setFrameTime(60);
                }
            })
        },
        receive(captcha,scene) {
            if (this.audition) {
                if (!this.tel && !this.captcha) {
                    this.$toast(
                        {
                            message: "请输入手机号和验证码",
                            position: 'top',
                        });
                } else if (!this.tel) {
                    this.$toast(
                        {
                            message: "请输入手机号",
                            position: 'top',
                        });
                } else if (!this.captcha) {
                    this.$toast(
                        {
                            message: "请输入验证码",
                            position: 'top',
                        });
                } else if (this.tel && this.captcha) {
                    this.postAccountLoginByAuthCode(scene);
                }
            } else {
                if (this.captcha) {
                    this.postAccountLoginByAuthCode(scene);
                } else {
                    this.$toast(
                        {
                            message: "请输入验证码",
                            position: 'top',
                        });
                }
            }
        },
        async getFindUserBranchList (scene) {
            localStorage.removeItem('branchList')
            localStorage.removeItem('code')
            localStorage.removeItem('organ')
            localStorage.removeItem('actor')
            localStorage.removeItem('branch')
            localStorage.removeItem('channel')
            return this.$api.account.getFindUserBranchList({}).then(res => {
                if (res.data && res.data.length) {
                    this.branchList = res.data.filter(item => Object.prototype.toString.call(item) === '[object Object]').map(item => {
                        return {
                            text: item.name,
                            value: item.branch,
                            actor: item.actor,
                            organ: item.organ,
                            channel: item.channel,
                            code: item.code
                        }
                    })
                    if (!this.branchList.length) return
                    localStorage.setItem('branchList', JSON.stringify(this.branchList))
                    localStorage.setItem('code', res.data[0].code)
                    localStorage.setItem('organ', res.data[0].organ)
                    localStorage.setItem('actor', res.data[0].actor)
                    localStorage.setItem('branch', res.data[0].branch)
                    res.data[0].channel && localStorage.setItem('channel', res.data[0].channel)
                    this.$sensors.login(res.data[0].code)
                    
                    this.getApplyStaus(this.goodsId);
                    // 发送请求判断是否已购买
                    this.checkUserCanByGoods(this.goodsId,scene);
                }
            })
        },
        // 登录注册
        async postAccountLoginByAuthCode (scene) {
            const data = {
                account: this.purchasePhone,
                authCode: this.captcha,
                distributionId: this.agentId
            };
            await this.$api.usercenter
                .postAccountLoginByAuthCode({ data })
                .then(async res => {
                    if (res.code != 0) {
                        if(this.buttonType==1 || this.buttonType==2){
                            this.$sensors.track('get_course',{
	                            current_page: "一元课", 
	                            current_scene: scene, 
                                phone_number:this.purchasePhone,
                                is_succeed:res.success?1:0,
                                failed_reason:res.message
                            })
                        }
                        if(this.buttonType==3){
                            this.$sensors.track('get_course',{
	                            current_page: "一元课", 
	                            current_scene: scene, 
                                phone_number:this.tel,
                                is_succeed:res.success?1:0,
                                failed_reason:res.message
                            })
                        }
                        this.$notify(res.message);
                        return false;
                    }
                    if (res.data) {
                        localStorage.setItem("token", res.data);
                        this.token = res.data;
                        await localStorage.setItem(
                            "WDuserInfo",
                            JSON.stringify(this.$store.state.userInfo)
                        );
                        this.purchasePhone1 = null;
                        this.purchasePhone2 = null;
                        this.tel = null;
                        this.captcha = null;
                        this.receiveDialogVisible = false;
                        this.getFindUserBranchList(scene);
                        // this.getApplyStaus(this.goodsId);
                        // // 发送请求判断是否已购买
                        // this.checkUserCanByGoods(this.goodsId);
                    } else {
                        return res.data;
                    }
                })
                .catch(() => {
                    if(this.buttonType==1 || this.buttonType==2){
                        this.$sensors.track('get_course',{
	                        current_page: "一元课", 
	                        current_scene: scene, 
                            phone_number:this.purchasePhone,
                            is_succeed:0,
                            failed_reason:'验证码错误'
                        })
                    }
                    if(this.buttonType==3){
                        this.$sensors.track('get_course',{
	                        current_page: "一元课", 
	                        current_scene: scene, 
                            phone_number:this.tel,
                            is_succeed:0,
                            failed_reason:'验证码错误'
                        })
                    }
                    this.$toast(
                        {
                            message: "验证码错误",
                            position: 'top',
                        });
                    return false;
                });
        },
        apply(scene,consult) {
            this.consult="活动有效期抢"
            this.$sensors.track('click_button',{
	            current_page: "一元课", 
	            button_name: scene, 
                consult:consult
            })
            if(this.isOverdue) {
                this.$toast({
                    message: "活动已过期",
                    position: 'top',
                })
                return 
            }
            // if (this.token) {
            //     // 发送请求判断是否已购买
            //     this.checkUserCanByGoods(this.goodsId);
            // } else {
                this.audition = true;
                this.disabled = false;
                this.buttonType=3
                this.tel = null;
                this.captcha = null;
                this.receiveDialogVisible = true;
                this.submitText = "";
                clearInterval(this.knowTime);
            }
        // }
    },
};
/*eslint-disable no new*/
</script>
<style scoped lang="less">
@import url("../asset/css/oneYuanGiftBag");
</style>
